import { getImageDimensions, SanityImageSource } from '@sanity/asset-utils';
import classNames from 'classnames';
import Image from "next/legacy/image";
import { useCallback } from 'react';
import { urlFor } from '../../utils/sanityUtils';

interface BlankImageProps {
  alt: string;
  className?: string;
  height?: number;
  priority?: boolean;
  removeEffect?: boolean;
  src: SanityImageSource;
  width: number;
}

const BlankImage = ({
  alt,
  className,
  height,
  priority = false,
  src,
  width,
  removeEffect = false,
}: BlankImageProps) => {
  const shouldCover = height !== undefined;
  const imageDimensions = getImageDimensions(src);

  const getImageProps = useCallback(() => {
    let ratio = width / imageDimensions.width;
    var smartHeight = imageDimensions.height * ratio;

    var newWidth = width;
    if (smartHeight > width) {
      newWidth = width / 1.5;
      smartHeight = smartHeight / 1.5;
    }

    return { width: newWidth, height: smartHeight };
  }, [imageDimensions, width]);

  const effectClass = classNames({
    'opacity-[0.85] mix-blend-multiply': removeEffect === false,
  });

  return (
    <div
      className={`relative ${
        !removeEffect && `bg-[#FFFCB6]`
      } leading-[0] ${className}`}
    >
      <Image
        src={urlFor(src).url()}
        alt={alt}
        width={getImageProps().width}
        height={shouldCover ? height : getImageProps().height}
        objectFit={shouldCover ? 'cover' : 'contain'}
        className={`${effectClass}`}
        priority={priority}
      />
    </div>
  );
};

export default BlankImage;
